import { render } from "./ActivityView.vue?vue&type=template&id=2b4737ec&scoped=true"
import script from "./ActivityView.vue?vue&type=script&lang=js"
export * from "./ActivityView.vue?vue&type=script&lang=js"

import "./ActivityView.vue?vue&type=style&index=0&id=2b4737ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4737ec"]])

export default __exports__